import { t } from "i18next";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { StaffPost, StaffPostById } from "../../../../../types/types";
import { useFetch } from "../../../../../hooks/useFetch";
import { useStaffPosts } from "../../../../../hooks/useFetchStateHooks/useStaffPosts";
import { ScrollArea } from "../../../../../ui/ScrollArea/ScrollArea";
import { Input } from "../../../../../ui/Input/Input";
import { Button } from "../../../../../ui/Button";
import DeletePosition from "../DeletePosition";
import { Separator } from "../../../../../ui/Separator";
import { useAppStore } from "../../../../../stores/RootStore";

type Props = {
  id: string | undefined;
  currentPost: StaffPostById | undefined;
};

const PostSettingsTab = ({ id, currentPost }: Props) => {
  let [isDeleteOpen, setIsDeleteOpen] = useState(false);
  //const [errors, setErrors] = useState([]);

  const { handleSubmit, control } = useForm({
    defaultValues: {
      post_name: currentPost?.attributes.name,
    },
  });

  // Обновление информации о сотруднике
  const [{ response: itemSaveResponse, isLoading: itemSaveIsLoading, error: itemSaveError }, doFetchItemSave] =
    useFetch(`/directories/posts/${id}`);

  const onSubmit = (formData: any) => {
    doFetchItemSave({
      method: "PUT",
      data: {
        data: {
          name: formData.post_name,
        },
      },
    });
  };

  function openDeleteModal() {
    setIsDeleteOpen(true);
  }

  function closeDeleteModal() {
    setIsDeleteOpen(false);
  }

  const posts = useAppStore((store) => store.posts)!;
  const setPosts = useAppStore((store) => store.setPosts);

  const editPostItem = (itemSaveResponse: { data: unknown }) => {
    const newCurrentItemData = itemSaveResponse.data as unknown as StaffPost;
    const withoutCurrentItem = posts?.filter((post) => post.id != currentPost?.id)!;
    setPosts([...withoutCurrentItem, newCurrentItemData]);
  };

  useEffect(() => {
    if (!itemSaveResponse) return;
    editPostItem(itemSaveResponse);
  }, [itemSaveResponse]);

  return (
    <>
      <div>
        <form onSubmit={handleSubmit(onSubmit)}>
          <ScrollArea>
            <div className="flex flex-col gap-3">
              <Controller
                name="post_name"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <div className="relative space-y-2">
                    <Input {...field} label={t("post_name")} />
                  </div>
                )}
              />
              <div className="mt-8 flex w-full justify-between">
                <Button variant={"destructive"} size={"sm"} type="button" onClick={() => openDeleteModal()}>
                  {t("delete")}
                </Button>
                <Button variant={"default"} size={"sm"} type="submit">
                  {t("save")}
                </Button>
              </div>
            </div>
          </ScrollArea>
        </form>
      </div>
      <DeletePosition id={id!} isDeleteOpen={isDeleteOpen} closeModal={closeDeleteModal} />
    </>
  );
};

export default PostSettingsTab;
